import React, { useContext, useEffect, useState, useCallback } from 'react';
import { Button, Grid, TableCell, TableRow, TableContainer, Table, TableHead, TableBody, Checkbox } from '@material-ui/core';
import { SecondaryButton, TextBox } from '../../../Core/FormInput';
import { makeStyles, withStyles } from '@material-ui/styles';
import AppContext from '../../../App/AppContext';
import { GetTCards_GetCustomerNotifications, postTCard_AddUpdateCustomerNotifications } from '../../../Core/Service/T-card-services';
import PhoneForwardedIcon from '@material-ui/icons/PhoneForwarded';
import AllInboxIcon from '@material-ui/icons/AllInbox';
import GetAppIcon from '@material-ui/icons/GetApp';

const useStyles = makeStyles({
    table: { minWidth: 1000 },
    tableContainer: { height: 650, border: '1px solid rgba(0,0,0,0.2)' },
    actionIcon: { fontSize: 16, cursor: 'pointer' }
});

const StyledTableRow = withStyles(() => ({
    root: { cursor: 'pointer' }
}))(TableRow);

const StyledTableCell = withStyles(() => ({
    head: { fontSize: 15, fontWeight: 600, backgroundColor: '#bdbdbd82' },
    body: { fontSize: 14, padding: '0px 10px 0px 16px' }
}))(TableCell);

const AddEditCustomer = ({ selectedCustomerID, selectedCustomer, onClose }) => {
    const { showToast } = useContext(AppContext);
    const classes = useStyles();
    const [loading, setLoading] = useState(false);
    const [tCardLineItems, setTCardLineItems] = useState([]);

    useEffect(() => {
        const fetchNotifications = async () => {
            const res = await GetTCards_GetCustomerNotifications(selectedCustomerID);
            if (res.success) {
                setTCardLineItems(res.data.notifications || []);
            }
        };
        fetchNotifications();
    }, [selectedCustomerID]);

    const handleCheckbox = useCallback(
        (id, name) => (e) => {
            setTCardLineItems((prevItems) => prevItems.map((item) => (item.statusID === id ? { ...item, [name]: e.target.checked } : item)));
        },
        []
    );

    const handleChange = useCallback(
        (id, name) => (e) => {
            setTCardLineItems((prevItems) => prevItems.map((item) => (item.statusID === id ? { ...item, [name]: e.target.value } : item)));
        },
        []
    );

    const setAllEmails = () => {
        if (!selectedCustomer?.e) return;
        setTCardLineItems((prevItems) => prevItems.map((item) => ({ ...item, email: selectedCustomer.e })));
    };

    const setAllPhones = () => {
        if (!selectedCustomer?.p) return;
        setTCardLineItems((prevItems) => prevItems.map((item) => ({ ...item, phone: selectedCustomer.p })));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);

        try {
            const data = {
                notifications: tCardLineItems.map(({ id, customerID, statusID, sendEmail, email, sendSMS, phone }) => ({
                    tCardCustomerNotificationID: id,
                    tCardCustomerNotificationCustomerID: customerID,
                    tCardCustomerNotificationJobStatusID: statusID,
                    tCardCustomerNotificationSendEmail: sendEmail,
                    tCardCustomerNotificationEmail: email,
                    tCardCustomerNotificationSendSMS: sendSMS,
                    tCardCustomerNotificationPhone: phone
                }))
            };

            const res = await postTCard_AddUpdateCustomerNotifications(selectedCustomerID, data);
            if (res.data.success) {
                showToast(res.data.message);
                onClose(true);
            } else {
                console.error(res.message);
            }
        } catch (error) {
            console.error('Error submitting data:', error);
        } finally {
            setLoading(false);
        }
    };

    return (
        <Grid container>
            <TableContainer className={classes.tableContainer}>
                <Table className={classes.table} size="small" stickyHeader>
                    <TableHead>
                        <TableRow>
                            <StyledTableCell width="30%">Job Status</StyledTableCell>
                            <StyledTableCell width="5%">Send Email</StyledTableCell>
                            <StyledTableCell width="45%" align="center">
                                Email{' '}
                                <GetAppIcon
                                    titleAccess="Click here to copy email to all status below"
                                    className={classes.actionIcon}
                                    color="primary"
                                    onClick={setAllEmails}
                                />
                            </StyledTableCell>
                            <StyledTableCell width="5%">Send Text</StyledTableCell>
                            <StyledTableCell width="40%" align="center">
                                Mobile{' '}
                                <GetAppIcon
                                    titleAccess="Click here to copy phone to all status below"
                                    className={classes.actionIcon}
                                    color="primary"
                                    onClick={setAllPhones}
                                />
                            </StyledTableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {tCardLineItems.map(({ status, statusID, sendEmail, email, sendSMS, phone }) => (
                            <StyledTableRow key={statusID}>
                                <StyledTableCell>{status}</StyledTableCell>
                                <StyledTableCell>
                                    <Checkbox checked={sendEmail} onChange={handleCheckbox(statusID, 'sendEmail')} />
                                </StyledTableCell>
                                <StyledTableCell>
                                    <TextBox onChange={handleChange(statusID, 'email')} value={email} />
                                </StyledTableCell>
                                <StyledTableCell>
                                    <Checkbox checked={sendSMS} onChange={handleCheckbox(statusID, 'sendSMS')} />
                                </StyledTableCell>
                                <StyledTableCell>
                                    <TextBox onChange={handleChange(statusID, 'phone')} value={phone} />
                                </StyledTableCell>
                            </StyledTableRow>
                        ))}
                    </TableBody>
                </Table>
            </TableContainer>
            <Grid item xs={12} style={{ marginTop: 20, marginBottom: 15 }}>
                <SecondaryButton fullWidth onClick={handleSubmit} disabled={loading}>
                    {loading ? 'Submitting...' : 'Submit'}
                </SecondaryButton>
            </Grid>
        </Grid>
    );
};

export default AddEditCustomer;
